<script setup>
import { ref } from 'vue';
import { useForm } from '@inertiajs/inertia-vue3';

import CreateOrganisation from '@/Pages/Organisations/Create.vue';

const form = useForm({
    name: '',
    abn: '',
    street_address: '',
    city: '',
    postal_code: '',
    state: '',
    phone: '',
    email: '',
    website: '',
    joined_date: '',
    membership_level: '',
    payment_frequency: ''
});

defineProps({
    errors: {
        type: Object,
        default: () => ({}),
    },
    app: {
        type: Object,
        default: () => ({}),
    },
})

function createOrganisation() {
    form.post('/organisations')
}
</script>

<template>
	<CreateOrganisation 
		:organisation="form"
		:errors="errors"
		:app="app"
		@create:organisations="createOrganisation"
	/>
</template>